import { Text } from '@hhgtech/hhg-components/mantine'
import { Box } from '@mantine/core'
import { useIntl } from 'react-intl'

import { useRouterExtend } from 'hooks/useRouterExtend'
import { LOCALE } from 'interfaces/types'

import { Props } from './index'
import useStyles from './index.styles'
import { CopyInput } from '../copyInput'
import { SocialItemEle } from '../socialItemEle'
import { SocialItem } from '../types'

const AsideNavView = ({
  shareUrl,
  iconSize = 28,
  styles,
  className,
  classNames,
  bgColor,
  socialList,
  ...rest
}: Props & { socialList: SocialItem[] }) => {
  const { locale } = useRouterExtend()
  const { formatMessage: f } = useIntl()
  const { classes, cx } = useStyles(
    { isVn: locale === LOCALE.Vietnam },
    {
      name: 'ShareBox--AsideNav',
      styles,
      classNames,
    },
  )

  return (
    <Box className={cx(className, classes.root)} {...rest}>
      <Text size="n1" className={classes.heading}>
        {f({ id: 'shareArticle.asideNav.share', defaultMessage: 'Share' })}
      </Text>
      {socialList.map((social: SocialItem, index: number) => (
        <SocialItemEle
          key={index}
          social={social}
          iconSize={iconSize}
          bgZaloColor={bgColor || '#fff'}
          zaloLayout={3}
          dataEventAction={social.name}
        />
      ))}
      <CopyInput
        shareUrl={shareUrl}
        type="button"
        classNames={{
          root: classes.copyRoot,
          heading: classes.copyHeading,
          inputWrapper: classes.copyInputWrapper,
          inputRightSection: classes.copyInputRightSection,
          input: classes.copyInput,
          btn: classes.copyBtn,
        }}
      />
    </Box>
  )
}

export default AsideNavView
